import { render } from "./StagesView.vue?vue&type=template&id=b4bc323c&scoped=true&ts=true&lang=pug"
import script from "./StagesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StagesView.vue?vue&type=script&lang=ts&setup=true"

import "./StagesView.vue?vue&type=style&index=0&id=b4bc323c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bc323c"]])

export default __exports__